var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReviewUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.88 8.13083L10.0308 10.9808L8.1308 9.08083L6.23163 10.9808",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9558 5.15587C16.3858 7.5859 16.3858 11.5258 13.9558 13.9558C11.5258 16.3858 7.58591 16.3858 5.1559 13.9558C2.72587 11.5258 2.72587 7.58588 5.1559 5.15587C7.58593 2.72584 11.5258 2.72584 13.9558 5.15587",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 16.6667L13.9583 13.9583",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReviewUnselected);
export default __webpack_public_path__ + "static/media/icon_review_unselected.7c4deda5b7e9f538c3568c9aa0078d60.svg";
export { ForwardRef as ReactComponent };